import { useEffect } from "react";
import { withRouter } from 'react-router-dom';

const PageScrollTop = (props) => {
    const { hash, pathname } = props.location;
    useEffect(() => {
        if (hash) {
            // Target sections are lazy-loaded; poll until the element mounts.
            let tries = 0;
            const timer = setInterval(() => {
                const el = document.getElementById(hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    clearInterval(timer);
                } else if (++tries > 40) {
                    clearInterval(timer);
                }
            }, 100);
            return () => clearInterval(timer);
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return props.children;
};
export default withRouter(PageScrollTop);
